import { Note } from "../../Data/HexMap/Note"
import { Coordinates } from "../../Util/Math/Coordinates"

export class NoteCtrlMenuState{
    setter:Function
    note:Note|null
    coordinates:Coordinates
    setMap:Function
    isOpen:boolean
    constructor(setter:Function){
      this.isOpen = false
      this.setter = setter
      this.note = null
      this.coordinates = new Coordinates(200,200)
      this.setMap = ()=>{}
    }
    setIsOpen = (b:boolean) => {
      const openSetter = (state:NoteCtrlMenuState)=>{
        return({ isOpen:b})
      }
      this.setter(openSetter)
    }
    setNote = (note:Note) => {
      const noteSetter = (state:NoteCtrlMenuState)=>{
        return({ note: note })
      }
      this.setter(noteSetter)
    }
    setCoordinates = (coords:Coordinates) => {
      const coordsSetter = (state:NoteCtrlMenuState)=>{
        return({ coordinates: coords })
      }
      this.setter(coordsSetter)     
    }
    setNoteConfig = (note:Note, coords:Coordinates, setMap:Function) => {
     const configSetter = (state:NoteCtrlMenuState)=>{
        return({ isOpen:true, coordinates: coords, note:note, setMap:setMap })
      }
      this.setter(configSetter)
    }
    setState = (obj:any) => {
      this.setter((state:NoteCtrlMenuState) => (obj))
    }
  }